export var DEPLOY_DATE = new Date('2026-10-22T09:56:26+0000');
